<div *ngIf="alert && alert.data">
  <!-- Con stacked: fila de titulo + acciones arriba y respuestas centradas abajo -->
  <div
    class="d-flex mb-2"
    [ngClass]="stacked ? 'flex-column' : 'flex-column flex-lg-row'"
    [style.gap.px]="stacked ? 6 : 30"
  >
    <div class="d-flex align-items-center gap-10" [style.width]="stacked ? '100%' : '220px'">
      <button
        class="monitor-retry-btn"
        type="button"
        (click)="individualAction(alert)"
        [title]="'testing.resend-ration' | translate"
      >
        <app-image-color
          [height]="'18px'"
          [width]="'18px'"
          [url]="'img/icons/reinicio-blanco.svg'"
          [color]="'#999999'"
        ></app-image-color>
      </button>
      <div>
        <h4 class="m-0 monitor-title">{{validateText(alert.alert)}}</h4>
        <div class="monitor-meta">
          <span *ngIf="alert.alert === 'monitor'">
            <em class="fa fa-calendar"></em>
            <small>{{ convertTimeZone(alert) | date : "mediumDate" : timezone }}</small>
          </span>
          <!-- Panel de testeos: junto a la fecha, la hora exacta (local) en que llego la respuesta -->
          <span
            *ngIf="stacked && alert.received_at"
            placement="top"
            container="body"
            [ngbTooltip]="'panel-alerts.monitor.received-at' | translate"
          >
            <span class="monitor-meta-sep" *ngIf="alert.alert === 'monitor'">·</span>
            <em class="fa fa-clock"></em>
            <small>{{ alert.received_at | date: "HH:mm:ss" }}</small>
          </span>
          <!-- Panel de estanques: la duracion se queda en esta linea, como antes -->
          <span *ngIf="!stacked && alert.data && !alert.data.hasOwnProperty('emptied')">
            <span class="monitor-meta-sep" *ngIf="alert.alert === 'monitor'">·</span>
            <em class="fa fa-clock"></em>
            <small>{{formatDuration(alert.time)}}</small>
          </span>
        </div>
      </div>
      <!-- Lado derecho: tiempo que tardo la respuesta (reloj de arena) + acciones del contenedor -->
      <div class="monitor-side" [class.is-stacked]="stacked">
        <span
          class="monitor-duration"
          *ngIf="stacked && alert.data && !alert.data.hasOwnProperty('emptied')"
          placement="top"
          container="body"
          [ngbTooltip]="'panel-alerts.monitor.duration' | translate"
        >
          <em class="fa fa-hourglass-half"></em>
          <small>{{formatDuration(alert.time)}}</small>
        </span>
        <ng-content select="[monitorActions]"></ng-content>
      </div>
    </div>
    <div>
      <div class="view_alert" [class.justify-content-center]="stacked">
        <div class="item" *ngIf="alert.data.hasOwnProperty('battery') && alert.alert === 'battery'">
          <div class="d-flex align-items-center">
            <div
              class="bg-alert w-100"
              [ngStyle]="{'background-color': validateColorImage(alert.data, 'battery','#B6D7A8','#F1C232','#EA9999')}"
            >
              <div class="d-flex align-items-center">
                <app-icon-battery
                  [value]="alert.data.battery"
                  [height]="'13px'"
                  [width]="'25px'"
                  [font_size]="'13px'"
                  [color]="validateColorImage(alert.data, 'battery','#009E0F','#FF9900','#CF2A27')"
                  [dark]="true"
                ></app-icon-battery>
                <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.battery" | translate }}</p>
              </div>
              <p class="m-0 text-dark">{{alert.data.battery}}</p>
            </div>
          </div>
        </div>

        <div class="item" *ngIf="alert.data.hasOwnProperty('emptied') && alert.alert === 'empty'">
          <div class="d-flex align-items-center">
            <div
              class="bg-alert w-100"
              [ngbTooltip]="alert.data.emptied ? ('panel-alerts.monitor.emptying' | translate) : ('panel-alerts.monitor.finished' | translate)"
              [class]="validateActive(alert.data.emptied)"
            >
              <p class="m-0 text-black" style="font-size: 12px; font-weight: bold; color: black">
                {{alert.data.emptied ? ('panel-alerts.monitor.emptying' | translate) :
                ('panel-alerts.monitor.finished' | translate)}}
              </p>
            </div>
          </div>
        </div>

        <div class="item" *ngIf="alert.data.hasOwnProperty('panel') && alert.alert === 'panel'">
          <div class="border-success d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngStyle]="{'background-color': validateColorImage(alert.data, 'panel','#B6D7A8','#F1C232','#EA9999')}"
            >
              <div class="d-flex align-items-center">
                <app-image-color
                  [height]="'10px'"
                  [width]="'30px'"
                  [value]="'panel: ' + alert.data.battery"
                  [url]="'img/icons/panel.svg'"
                  [color]="validateColorImage(alert.data, 'panel','#009E0F','#FF9900','#CF2A27')"
                ></app-image-color>
                <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.panel" | translate }}</p>
              </div>
              <p class="m-0 text-dark">{{alert.data.panel}}</p>
            </div>
          </div>
        </div>

        <div
          class="item"
          *ngIf="alert.data.hasOwnProperty('type') && (alert.alert === 'reset' || alert.alert === 'refeed')"
        >
          <div class="bg-alert w-100 bg-alert-success">
            <p class="m-0">{{ "panel-alerts.monitor.done-successfully" | translate }}</p>
          </div>
        </div>

        <div class="item" *ngIf="alert.data.hasOwnProperty('version') && alert.alert === 'version'">
          <div
            class="bg-alert w-100 bg-alert-success justify-content-between"
            ngbTooltip="A{{alert.data.version}}"
          >
            <p class="m-0 ml-2 font-weight-bold">{{ "tables.version" | translate }}</p>
            <p class="m-0 text-dark">{{alert.data.version}}</p>
          </div>
        </div>
        <div class="item" *ngIf="alert.data.hasOwnProperty('db') && alert.alert === 'signal'">
          <div
            class="bg-alert w-100 bg-alert-success justify-content-between"
            ngbTooltip="{{alert.data.db}}"
          >
            <p class="m-0 ml-2 font-weight-bold">{{ "panel-alerts.monitor.signal" | translate }}</p>
            <p class="m-0 text-dark">{{alert.data.db}}</p>
          </div>
        </div>
        <div
          class="item"
          *ngIf="alert.data.hasOwnProperty('power') && alert.alert === 'turn_off' || alert.alert === 'turn_on'"
        >
          <div class="border-success d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngbTooltip]="alert.data.power ? ('clients.farm.on' | translate) : ('clients.farm.off' | translate)"
              [class]="validateActive(alert.data.power,'power')"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-power-off fa-1x"
                  [style.color]="alert.data.power ? '#009E0F': '#CF2A27'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">
                  {{alert.data.power ? ('clients.farm.on' | translate) : ('clients.farm.off' |
                  translate)}}
                </p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.power ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.power ? '#009E0F': '#CF2A27'"
              ></em>
            </div>
          </div>
        </div>
        <div
          class="item"
          *ngIf="alert.data.hasOwnProperty('spin_time') && (alert.alert === 'turn_off_spin_time' || alert.alert === 'turn_on_spin_time')"
        >
          <div class="border-success d-flex align-items-center">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngbTooltip]="alert.data.spin_time ? ('panel-alerts.monitor.activated' | translate) : ('panel-alerts.monitor.deactivated' | translate)"
              [class]="validateActive(alert.data.spin_time)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-spin_time-off fa-1x"
                  [style.color]="alert.data.spin_time ? '#009E0F': '#CF2A27'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">
                  {{alert.data.spin_time ? ('panel-alerts.monitor.activated' | translate) :
                  ('panel-alerts.monitor.deactivated' | translate)}}
                </p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.spin_time ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.spin_time ? '#009E0F': '#CF2A27'"
              ></em>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="alert.alert === 'monitor'">
    <div class="view_alert" [class.justify-content-center]="stacked">
      <!-- TYPE RESET -->

      <div class="item" *ngIf="alert.data.hasOwnProperty('power')">
        <div class="border-success d-flex align-items-center">
          <div
            class="bg-alert w-100 justify-content-between"
            [ngbTooltip]="alert.data.power ? ('clients.farm.on' | translate) : ('clients.farm.off' | translate)"
            [class]="validateActive(alert.data.power , 'power')"
          >
            <div class="d-flex align-items-center">
              <em
                class="fa fa-power-off fa-1x"
                [style.color]="alert.data.power ? '#009E0F': '#CF2A27'"
              ></em>
              <p class="m-0 ml-2 font-weight-bold">
                {{alert.data.power ? ('clients.farm.on' | translate) : ('clients.farm.off' |
                translate)}}
              </p>
            </div>
            <em
              class="fa"
              [class]="!alert.data.power ? 'fa-times-circle' : 'fa-check-circle'"
              [style.color]="alert.data.power ? '#009E0F': '#CF2A27'"
            ></em>
          </div>
        </div>
      </div>

      <div class="item" *ngIf="alert.data.hasOwnProperty('battery')">
        <div class="border-success d-flex align-items-center">
          <div
            class="bg-alert w-100 justify-content-between"
            [ngStyle]="{'background-color': validateColorImage(alert.data, 'battery','#B6D7A8','#F1C232','#EA9999')}"
          >
            <div class="d-flex align-items-center">
              <app-icon-battery
                [value]="alert.data.battery"
                [height]="'13px'"
                [width]="'25px'"
                [font_size]="'13px'"
                [color]="validateColorImage(alert.data, 'battery','#009E0F','#FF9900','#CF2A27')"
                [dark]="true"
              ></app-icon-battery>
              <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.battery" | translate }}</p>
            </div>
            <p class="m-0 text-dark">{{alert.data.battery}}</p>
          </div>
        </div>
      </div>
      <div class="item" *ngIf="alert.data.hasOwnProperty('panel')">
        <div class="border-success d-flex align-items-center">
          <div
            class="bg-alert w-100 justify-content-between"
            [ngStyle]="{'background-color': validateColorImage(alert.data, 'panel','#B6D7A8','#F1C232','#EA9999')}"
          >
            <div class="d-flex align-items-center">
              <app-image-color
                [height]="'10px'"
                [width]="'30px'"
                [value]="'panel: ' + alert.data.panel"
                [url]="'img/icons/panel.svg'"
                [color]="validateColorImage(alert.data, 'panel','#009E0F','#FF9900','#CF2A27')"
              ></app-image-color>
              <p class="m-0 ml-2 font-weight-bold">{{ "alerts.general.panel" | translate }}</p>
            </div>
            <p class="m-0 text-dark">{{alert.data.panel}}</p>
          </div>
        </div>
      </div>
      <!--   <div
          class="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3"
          *ngIf="alert.data.hasOwnProperty('type')"
        >
          <p class="m-0">
            <b>{{'testing.empty-feeder' | translate}}: </b>{{alert.data.type}}
          </p>
        </div> -->

      <div class="item" *ngIf="alert.data.hasOwnProperty('dispenser')">
        <div class="border-success d-flex align-items-center">
          <div
            class="bg-alert w-100 justify-content-between"
            [class]="validateActive(alert.data.dispenser,'dispenser')"
            [ngbTooltip]="alert.data.dispenser ? ('general.yes' | translate) : ('general.no' | translate)"
            [ngStyle]="{'background-color': validateColorImage(alert.data, 'dispenser','#B6D7A8','#F1C232','#EA9999')}"
          >
            <div class="d-flex align-items-center">
              <app-image-color
                [height]="'10px'"
                [width]="'22px'"
                [url]="'img/alerts/dosificador.svg'"
                [color]="alert.data.dispenser ? '#CF2A27' : '#009E0F'"
              ></app-image-color>
              <p class="m-0 ml-2 font-weight-bold">
                {{ "settings-modal.dispenser-alert" | translate }}
              </p>
            </div>
            <em
              class="fa"
              [class]="alert.data.dispenser ? 'fa-times-circle' : 'fa-check-circle'"
              [style.color]="alert.data.dispenser ? '#CF2A27' : '#009E0F'"
            ></em>
          </div>
        </div>
      </div>
      <div class="item" *ngIf="alert.data.hasOwnProperty('sprinkler')">
        <div class="border-success d-flex align-items-center">
          <div
            class="bg-alert w-100 justify-content-between"
            [class]="validateActive(alert.data.sprinkler)"
            [ngbTooltip]="alert.data.sprinkler ? ('general.yes' | translate) : ('general.no' | translate)"
            [ngStyle]="{'background-color': validateColorImage(alert.data, 'sprinkler','#B6D7A8','#F1C232','#EA9999')}"
          >
            <div class="d-flex align-items-center">
              <app-image-color
                [height]="'17px'"
                [width]="'22px'"
                [url]="
                  alert.data.sprinkler
                    ? 'img/alerts/aspersor-alert.svg'
                    : 'img/icons/aspersor.svg'
                "
                [color]="alert.data.sprinkler ? '#CF2A27' : '#009E0F'"
              ></app-image-color>
              <p class="m-0 ml-2 font-weight-bold">
                {{ "clients.farm.sprinkler-alert" | translate }}
              </p>
            </div>
            <em
              class="fa"
              [class]="alert.data.sprinkler ? 'fa-times-circle' : 'fa-check-circle'"
              [style.color]="alert.data.sprinkler ? '#CF2A27' : '#009E0F'"
            ></em>
          </div>
        </div>
      </div>
      <div
        class="item"
        *ngIf="alert.data.hasOwnProperty('port') && globalFunction.validateSoloAdmin()"
      >
        <div
          class="bg-alert w-100 bg-alert-success justify-content-between"
          ngbTooltip="A{{alert.data.port}}"
        >
          <p class="m-0 ml-2 font-weight-bold">{{ "tables.port" | translate }}</p>
          <p class="m-0 text-dark">A{{alert.data.port}}</p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="globalFunction.validateSoloAdmin()">
      <div
        class="col-6"
        *ngIf="alert.data.hasOwnProperty('speed_enabled') || alert.data.hasOwnProperty('orbital_enabled')"
      >
        <b>{{ "tables.speed" | translate }}</b>
        <div class="view_alert justify-content-start">
          <div class="item" *ngIf="alert.data.hasOwnProperty('speed_enabled') ">
            <div
              class="bg-alert w-100 justify-content-between"
              [ngbTooltip]="alert.data.speed_enabled ? ('panel-alerts.monitor.activated-f' | translate) : ('panel-alerts.monitor.deactivated-f' | translate)"
              [class]="validateActive(alert.data.speed_enabled)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fas fa-tachometer-alt fa-1x"
                  [style.color]="alert.data.speed_enabled ? '#009E0F': '#cccccc'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">{{ "tables.speed" | translate }}</p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.speed_enabled ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.speed_enabled ? '#009E0F': '#cccccc'"
              ></em>
            </div>
          </div>
          <div class="item" *ngIf="alert.data.hasOwnProperty('orbital_enabled')">
            <div
              class="bg-alert w-100 justify-content-between aling-items-center"
              [ngbTooltip]="alert.data.orbital_enabled ? ('panel-alerts.monitor.activated-f' | translate) : ('panel-alerts.monitor.deactivated-f' | translate)"
              [class]="validateActive(alert.data.orbital_enabled)"
            >
              <div class="d-flex align-items-center">
                <div
                  class="circle-o"
                  *ngIf="alert.data.orbital_enabled"
                  [style.border]="'3px solid #009e0f'"
                ></div>
                <div
                  class="circle-o"
                  *ngIf="!alert.data.orbital_enabled"
                  [style.border]="'3px solid #cccccc'"
                >
                  <div
                    class="point"
                    [style.background]="alert.data.orbital_enabled ? '#009E0F': '#cccccc'"
                  ></div>
                </div>
                <p class="m-0 ml-2 font-weight-bold">{{ "speed-config.orbital" | translate }}</p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.orbital_enabled ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.orbital_enabled ? '#009E0F': '#cccccc'"
              ></em>
            </div>
          </div>
        </div>
        <!-- <ng-container *ngIf="alert.data.hasOwnProperty('fuzzy_logic_state') ">
          <b>Nas 2025</b>
          <div class="view_alert justify-content-start">
            <div
              class="item"
              *ngIf="alert.data.hasOwnProperty('fuzzy_logic_state') "
            >
              <div
                class="bg-alert w-100 justify-content-between"
                ngbTooltip="{{alert.data.fuzzy_logic_state ? 'Activada': 'Desactivada'}}"
                [class]="validateActive(alert.data.fuzzy_logic_state)"
              >
                <div class="d-flex align-items-center">
                  <p class="m-0 ml-2 font-weight-bold">Nas 2025</p>
                </div>
                <em
                  class="fa"
                  [class]="!alert.data.fuzzy_logic_state ? 'fa-times-circle' : 'fa-check-circle'"
                  [style.color]="alert.data.fuzzy_logic_state ? '#009E0F': '#cccccc'"
                ></em>
              </div>
            </div>
          </div>
        </ng-container> -->
      </div>
      <!-- <div
        class="col-6"
        *ngIf="alert.data.hasOwnProperty('sensors_enabled') || alert.data.hasOwnProperty('frequencies_mode')"
      >
        <b>Sensores ambientales</b>
        <div class="view_alert justify-content-start">
          <div
            class="item"
            *ngIf="alert.data.hasOwnProperty('sensors_enabled') && globalFunction.validateSoloAdmin()"
          >
            <div
              class="bg-alert w-100 justify-content-between"
              ngbTooltip="{{alert.data.sensors_enabled ? 'Activada': 'Desactivada'}}"
              [class]="validateActive(alert.data.sensors_enabled)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-thermometer-full fa-1x"
                  [style.color]="alert.data.sensors_enabled ? '#009E0F': '#cccccc'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">Estatus</p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.sensors_enabled ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.sensors_enabled ? '#009E0F': '#cccccc'"
              ></em>
            </div>
          </div>
          <div class="item" *ngIf="alert.data.hasOwnProperty('frequencies_mode')">
            <div
              class="bg-alert w-100 justify-content-between"
              ngbTooltip="{{validateFrecuencyMode(alert.data.frequencies_mode)}}"
              [class]="validateActive(alert.data.frequencies_mode)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-calendar fa-1x"
                  [style.color]="alert.data.frequencies_mode ? '#009E0F': '#cccccc'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">
                  Frecuencia {{validateFrecuencyMode(alert.data.frequencies_mode)}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="item"
            *ngIf="alert.data.hasOwnProperty('set_point_enabled') && globalFunction.validateSoloAdmin()"
          >
            <div
              class="bg-alert w-100 justify-content-between"
              ngbTooltip="{{alert.data.set_point_enabled ? 'Activada': 'Desactivada'}}"
              [class]="validateActive(alert.data.set_point_enabled)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-calendar fa-1x"
                  [style.color]="alert.data.set_point_enabled ? '#009E0F': '#cccccc'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">Set points</p>
              </div>

              <em
                class="fa"
                [class]="!alert.data.set_point_enabled ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.set_point_enabled ? '#009E0F': '#cccccc'"
              ></em>
            </div>
          </div>
        </div>
        <b>Sensores hydro</b>
        <div class="view_alert justify-content-start">
          <div
            class="item"
            *ngIf="alert.data.hasOwnProperty('hydro_sensor_state') && globalFunction.validateSoloAdmin()"
          >
            <div
              class="bg-alert w-100 justify-content-between"
              ngbTooltip="{{alert.data.hydro_sensor_state ? 'Activada': 'Desactivada'}}"
              [class]="validateActive(alert.data.hydro_sensor_state)"
            >
              <div class="d-flex align-items-center">
                <em
                  class="fa fa-thermometer-full fa-1x"
                  [style.color]="alert.data.hydro_sensor_state ? '#009E0F': '#cccccc'"
                ></em>
                <p class="m-0 ml-2 font-weight-bold">Estatus</p>
              </div>
              <em
                class="fa"
                [class]="!alert.data.hydro_sensor_state ? 'fa-times-circle' : 'fa-check-circle'"
                [style.color]="alert.data.hydro_sensor_state ? '#009E0F': '#cccccc'"
              ></em>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
